module.exports = __webpack_public_path__ + "static/media/tipologia7.b4110cbc.png";